import {EVENTS, STATUS_CODE_OK} from 'common/domain/constants';
import {MODES,MODALS} from 'common/domain/constants';
import {Request} from 'common/domain/models/request';

class PeriodListMobileController {
  constructor($rootScope,
              $stateParams,
              $window,
              $state,
              $timeout,
              $scope,
              vacationUserDataService,
              vacationEmployeeRepositoryService,
              loadingMobileService) {
    'ngInject';
    this.rootScope = $rootScope;
    this.stateParams = $stateParams;
    this.state = $state;
    this.timeout = $timeout;
    this.isMobileApp = $window.innerWidth < 1024;
    this.UserDataService = vacationUserDataService;
    this.employeeRepositoryService = vacationEmployeeRepositoryService;
    this.loadingMobileService = loadingMobileService;
    this.scope = $scope;
    this.start();
  }

  $onInit() {
    this.year = this.stateParams.dateToLoad ? this.stateParams.dateToLoad.getFullYear() : new Date().getFullYear();
    this.userId = this.UserDataService.getEmployee().userId;
    if (!this.isInception()) {
      this.changeTitle();
    }
    this._requestData(this.userId, this.year, this.userInceptionId);
  }

  get requestModal() {
    const $modal = $(MODALS.REQUEST);

    if ($modal.length > 0) {
      $modal.on('hidden.bs.modal', () => {
        this.timeout(() => {
          this.startDate = '';
          this.requestHolidayMode = MODES.CREATE;
          delete this.requestModalOpenOn;
          delete this.periodToEdit;
        });
      });
    }

    return $modal;
  }

  modalExists() {
    return this.requestHolidayMode !== undefined;
  }

  start() {
    this.filters = [];
    this.format = '';
  }

  _requestData(userId,year, userInceptionId) {
    this.loaded = false;
    this.loadingMobileService.show();
    return this.employeeRepositoryService.getEmployee(userId, year, userInceptionId)
      .then((employee) => {
        this._loadData(employee);
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _loadData(employee) {
    this.currentEmployee = employee;
    this.allPeriods = employee.allPeriods;
    this.vacationCount = employee.getAgreementVacationCount();
    this.hasEventsToShow();
    this.loaded = true;
  }

  onChangeFilters($event) {
    this.filters = $event.filters;
  }

  changeTitle() {
    this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, {
      title: 'VACATIONS_ABSENCES.PERIOD_LIST.REQUEST_STATUS_MENU_TITLE'
    });
  }

  onRemovePeriod($event) {
    this.rootScope.$broadcast(EVENTS.CONTEXT_MENU_REMOVE, {period: $event.period});
  }

  onEditPeriod($event) {
    this.requestHolidayMode = MODES.EDIT;
    this.periodToEdit = $event.period;
    this.originalPeriod = angular.copy($event.period);
    this.periodToEdit.startDate = new Date(this.periodToEdit.startDate);

    if (this.periodToEdit.endDate) {
      this.periodToEdit.endDate = new Date(this.periodToEdit.endDate);
    }

    this._openRequestModal();
  }

  onAddPeriod($event) {
    this.requestHolidayMode = MODES.CREATE;
    this.requestModalOpenOn = Request.TYPES.ABSENCE;
    this.startDate = new Date($event.startDate);

    this._openRequestModal();
  }

  _openRequestModal() {
    this.timeout(() => this.requestModal.modal('show'));
  }

  openModalEvent(){
    this._openRequestModal();
    this.timeout(() => this.requestHolidayMode = MODES.EDIT,100);    
  }

  $onDestroy() {
    this.loadingMobileService.hide();
  }

  removePeriod({status}) {
    if (status === STATUS_CODE_OK) {
      this._requestData(this.userId, this.year, this.userInceptionId);
    }
  }

  editPeriodEvent({ startDate, endDate }) {
    this._requestData(this.userId, this.year, this.userInceptionId).then(() => {
      this.rootScope.$broadcast(EVENTS.ADD_PERIOD, {
        startDate: startDate.getMonth(),
        endDate: endDate,
      });
    });
  }

  hasEventsToShow() {
    this.isHolidayAbsenceEvents = this.allPeriods.some(event => {
      return event.type !== 'holiday';
    });
  }

  isInception() {
    return !!this.userInceptionId;
  }
}

export default PeriodListMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/periodListMobile/periodListMobile.controller.js